import { AuthState } from "../models/auth.models";

export const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  token: null,
  isLoading: true,
};

export const LOG_AUTH_STORE_KEY = '[AuthStore]'
